// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTable-DateTimeLoading_cls1__Y7AtA","cls2":"VeloTable-DateTimeLoading_cls2__AAWrq VeloTable-DateTimeLoading_cls1__Y7AtA"};